export default "/images/vendor/flag-icon-css/flags/1x1/uy.svg?d3a8689930e65cbe016009d7553a0780";